import { CommanSubscribeService } from './../../../../core/services/comman-subscribe.service';
import { API, CONST_AWS_API, COUNTRIES_LIST, CURRENCY_SYMBOLS } from './../../../../core/constants';
import { API as AWS_API } from 'aws-amplify';
import { Router, ActivatedRoute } from '@angular/router';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, Inject, Output, EventEmitter, Input } from '@angular/core';
import { AppPaymentTVService } from 'src/app/core/services/app-payment-tv.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { ConsumerSignInComponent } from '../../landing-pages/consumer/consumer-sign-in/consumer-sign-in.component';
import { UserService } from 'src/app/core/services/user.service';
import * as moment from 'moment';
// import { EventTermsConditionsComponent } from '../../event-navigation/pages/event-terms-conditions/event-terms-conditions.component';
import { ValidationService } from 'src/app/core/services/validation.service';
import { PaymentService } from 'src/app/core/services/payment.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { AppService } from 'src/app/core/services/app.service';
import { Subscription } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { PubNubService } from 'src/app/core/services/pubnub.service';

declare let window: any;

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {

  // loadAPI: Promise<any>;
  psInterval: ReturnType<typeof setInterval> | undefined; //NodeJS.Timer;;
  @Output() getPaymentData = new EventEmitter<any>();
  @Output() afterPaymentSuccess = new EventEmitter<any>();
  // @Output() backToHome = new EventEmitter<any>();
  @Input() backToHome: boolean;
  ccForm: FormGroup;
  billingForm: FormGroup;
  // paymentMode: string = "Credit Card";
  address: string;
  userInfo: any = {};
  streamInfo: any = {};
  paymentType = "";
  currency: any;
  finalAmount: any;
  // totalAmount: any;
  charityInfo: any = {};
  performerInfo: any = {};
  groupName: string = '';
  taxPercentage = 0;
  getPaymentDetailToken = "";
  isPaymentSuccess = false;

  @ViewChild('cardInfo', { static: false }) cardInfo: ElementRef;
  // @ViewChild('payamount', { static: true }) payamount: any;
  card: any;
  cardError: string;
  validStripeForm = false;
  redirectUrl = '';
  pastedText: any;
  invoice_id: any;
  showCCForm = false;
  taxAmount = 0;
  taxable: boolean = true;
  currentLocation: any;
  loadCss = `${environment.CONSUMER_PORTAL}assets/custom-css/paystand.css`;
  psKey: any;
  cardId: any;
  incl: any;
  codes: any = {};
  paymentData: any;
  paymentInfoSubscription: any;
  reopen: boolean;
  paymentSuccess: boolean = false;
  streamId: any;
  amount: any;
  USDAmount: any = [];
  GBPAmount: any = [];
  getAmount: any;
  isStateOptional: boolean;
  showDescription: boolean = false;
  countriesList = COUNTRIES_LIST;
  billingCountry: any = {};
  shippingCountry: any = {};
  options: {};
  countryChanged: boolean = true;
  isAgrees: boolean = false;
  ticket_type_name: string;
  getTicketIds: any = [];
  getQuestionsData: string;
  ticketsData: any;
  showShippingForm: boolean = false;
  ticketIds: any = [];
  getTicketIdInv: any;
  shippingForm: FormGroup;
  getCurrency: string;
  getCurrencytype: any;
  promoCode: string;
  isEnteredOtherUser: boolean = true;
  contactInfoForm: FormGroup;
  noOfTicket: any = 0;
  settingsJSON: any;
  processingFee: number;
  currencyVal: any;
  currenciesList: any = [];
  psSrc: string;
  deviceData: any;
  timezoneVal: any;
  curWithoutDecimals: any = ['BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA', 'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF'];
  allowDecimals: boolean = true;
  selectedCard: any = {};
  selectedCardInfoSubscr: Subscription;
  showBillingForm: boolean = false;
  addressList: any = [];
  addressListInfoSubscr: Subscription;
  savedCardsListSubscr: Subscription;
  savedCardsList: any = [];
  newShippingForm: boolean = false;
  addNewCard: boolean = false;
  selectedBillingAddress: any = {};
  userInfoSubscription: Subscription;
  assets_url = environment.assets_url;
  clientDetails: any;
  currentTheme: any;
  transactionInfoSubscr: Subscription;
  transactionInfo: any;
  formStatusSubscr: Subscription;
  selectedTransaction: any = "";
  cryptoToken: string;
  cryptoSymbol: string;
  USD_Rates: any;
  totalAmount: Subscription;
  currency_for_totAmt: any;
  amt_without_pf1: any;
  crypto_amount: any;
  sliced_crypto_amount: number;
  athletesData: any
  selectedAthleteDetails: any;
  organizationId: any;
  performerInfoSubscription!: Subscription;
  currentUserId: any;
  athleteControl = new FormControl('', Validators.required);
  paymentAreaClicked: boolean = false;
  @Input() activeBlock;
  @Input() isFromCommunityTips: boolean;
  channelDetails:any;
  conversionRate:number=1;
  selectedTip: any = null;
  @Input('settingsData') settingsData: any = {};

  constructor(private formBuilder: FormBuilder, private appPaymentService: AppPaymentTVService, private userService: UserService,
    private commanSubscribeService: CommanSubscribeService,
    public activatedRoute: ActivatedRoute, private toastr: ToastrService,
    private loader: NgxUiLoaderService, private cd: ChangeDetectorRef, private router: Router,
    public dialogRef: MatDialogRef<PaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any, private _matDialog: MatDialog,
    private paymentService: PaymentService, private appService: AppService,
    private commonSubscribeService: CommanSubscribeService,
    private pubnubService: PubNubService,
    private storageService: StorageService,) {
    this.getPaymentDetailToken = this._data?.token || this.activatedRoute.snapshot.params.token;
  }

  showOverlay: boolean = false;
  timer = 120;
  toggleLoader(state) {
    if (state != 'none') {
      this.showOverlay = true;
      var counter = 120;
      var interval = setInterval(() => {
        counter--;
        if (counter <= 0) {
          clearInterval(interval);
          return;
        } else {
          this.timer = counter;
        }
      }, 1000);
    }
    // var overlay = document.getElementsByClassName('ngx-overlay');
    // overlay[0]['style'].display = state;
    if (state == 'none') {
      this.loader.stop();
    }
  }

  getAwsData(body) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: body
    };
    this.loader.start();
    return data;
  }

  getStreamInfo(callback) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        "stream_id": this.streamId,
        "userid": this.userInfo.id,
      }
    }
    this.loader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_LIVE_EVENT_BY_ID, data).then(response => {
      this.loader.stop();
      callback(response.data.Data)
    }).catch(error => {
      this.loader.stop();
    });
  }

  getUserInfo(callback) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        // "Authorization": `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        "user_id": this.paymentData.user_id,
        "organization_id": this.organizationId
      }
    }
    this.loader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER_BY_ID, data).then(response => {
      this.loader.stop();
      if (response.data.user) {
        let token = this.getParam('token');
        if (token) {
          response.data.user.access_token = token
        } else {
          response.data.user.access_token = response.data.user.session_token;
        }
        this.userInfo = this.commanSubscribeService.userInfo = response.data.user;
        this.commanSubscribeService.sendUserInfo(this.userInfo);
      }
      callback();
    }).catch(error => {
      this.loader.stop();
    });
  }
  rates: any;
  minAmount: any;
  ngOnInit() {
    this.userInfo = this.commanSubscribeService.userInfo;
    this.currentUserId = 'fan_' + this.userInfo.id;
    this.organizationId = this.commanSubscribeService.perfomerInfoData?.data?.Data?.[0]?.organization_id;
    this.performerInfoSubscription = this.commanSubscribeService.getPerfomerInfo().subscribe(response => {
      this.organizationId = response?.data?.Data?.[0]?.organization_id;
    });
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
      this.currentUserId = 'fan_' + this.userInfo.id;
    });
    if (this.router.url.includes('/payment/')) {
      this.activeBlock = this.router.url.includes('/payment/performer_tip') ? "Tips" : "Donations";
    }
    this.clientDetails = environment.clientDetails;
    this.currentTheme = this.commanSubscribeService.getThemeColors();
    this.settingsData=this.settingsData;
    this.savedCardsListSubscr = this.commonSubscribeService.getSavedCards().subscribe(response => {
      this.savedCardsList = response;
      // if (this.savedCardsList.length == 0 && this.addressList.length > 0 && this.addressList.billingAddress.length == 0) {
      //   this.showBillingForm = true;
      // }

      if (this.savedCardsList.length == 0) {
        this.addNewCard = true;
      }
    })

    this.formStatusSubscr = this.commonSubscribeService.getFormStatus().subscribe(response => {
      if (response) {
        this.close(this.paymentType);
      }
    })

    this.selectedCardInfoSubscr = this.commonSubscribeService.getSelectedCardInfo().subscribe(response => {
      this.selectedCard = response;
      if (response) {
        this.showBillingForm = false;
        this.addNewCard = false;
      }
    });

    // this.addressListInfoSubscr = this.commonSubscribeService.getAddressList().subscribe(response => {
    //   this.addressList = response;
    //   if (this.addressList && this.addressList.billingAddress.length > 0) {
    //     let billingAdd = this.addressList.billingAddress.filter(a => a.billingAddress);
    //     this.showBillingForm = billingAdd.length > 0 ? true : false;
    //     let selectedAddress = this.addressList.billingAddress.filter(a => a.defaultBillingAddress);
    //     this.selectedBillingAddress = selectedAddress.length > 0 ? selectedAddress[0] : {};
    //   } else if (this.addressList.billingAddress.length == 0 && this.savedCardsList.length == 0) {
    //     this.showBillingForm = true;
    //   }
    // });
    this.clientDetails = environment.clientDetails;
    this.cryptoToken = this.clientDetails.crypto_token;
    this.cryptoSymbol = this.clientDetails.crypto_symbol;
    this.commonSubscribeService.getCurrencyRates("USD", result => {
      this.USD_Rates = result;

    });
    this.totalAmount = this.commonSubscribeService.getTotalAmount().subscribe(response => {
      this.currency_for_totAmt = response.currency;
      this.amt_without_pf1 = response.amt_without_pf;
      this.crypto_amount = this.commonSubscribeService.convertToCryptoAmount(this.amt_without_pf1, this.USD_Rates[this.currency_for_totAmt])
      this.sliced_crypto_amount = Math.trunc(this.crypto_amount * Math.pow(10, 3)) / Math.pow(10, 3);
    })

    this.transactionInfoSubscr = this.commonSubscribeService.getTransactionInfo().subscribe(response => {
      this.transactionInfo = response;
      this.card = this.transactionInfo["card"];
      if (this.selectedCard && this.selectedCard.id) {
        this.makePayment('card');
      } else {
        this.makePayment();
      }
    })

    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
      // if (this.userInfo && this.userInfo.is_guest) {
      //   this.showBillingForm = true;
      // }
    });

    // if (this.userInfo && this.userInfo.is_guest) {
    //   this.showBillingForm = true;
    // }

    this.timezoneVal = this.userService.getTimezone();
    this.getCurrency = this.storageService.getItem('currency');
    console.log(navigator.language);

    this.currentLocation = this.commanSubscribeService.locationInfo;
    this.getCurrency = this.storageService.getItem('currency');

    this.commanSubscribeService.getCurrenciesJSON().subscribe(result => {
      Object.keys(result).forEach(element => {
        let value = element + ' - ' + result[element]
        this.currenciesList.push(value);
      })
    });
    this.buildBillingForm();
    let locInfo = this.commonSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commanSubscribeService.getCurrentLocation((val: any, json: any) => {
        console.log(json);
        if (val == "fail") {
          this.currentLocation = this.currentLocation ? this.currentLocation : {};
        } else {
          this.currentLocation = json;
        }
        this.prepare();
      });
    } else {
      this.prepare();
    }

    // this.buildBillingForm();
    this.buildShippingForm();
    // this.payamount.nativeElement.focus();

    if (this.getPaymentDetailToken == 'pay_per_view') {
      this.isEnteredOtherUser = false;
      this.noOfTicket = this.getParam('noofticket');
      this.buildContactInfoForm();
    }

    this.deviceData = this.commonSubscribeService.getMobileOperatingSystem();

    this.getAthletesData();

    this.channelDetails = this.commanSubscribeService.spaceDetails;
    if (this.channelDetails?.recommendedTips && typeof this.channelDetails.recommendedTips === 'string') {
      this.channelDetails.recommendedTips = JSON.parse(this.channelDetails.recommendedTips);
    }

  }

  getAthletesData() {
    this.athletesData = this.commanSubscribeService.athletsData?.[0];
  }

  applyTip(value: any) {
    const convertedValue = (value * this.conversionRate).toFixed(2);
    this.selectedTip = value * this.conversionRate;
    this.billingForm.get('amount')?.setValue(convertedValue);
    this.amountChange(convertedValue);
    if (!this.isFromCommunityTips || this.selectedAthleteDetails) {
      this.commonSubscribeService.formsValidationSubject.next(true);
    }
  }

  newCard() {
    this.addNewCard = true;
    this.selectedCard = {};
    if (this.addressList.billingAddress.length == 0)
      this.showBillingForm = true;
    this.commonSubscribeService.selectedCardSubject.next(false);
  }

  showShortDesciption = false

  alterDescriptionText() {
    this.showShortDesciption = !this.showShortDesciption
  }

  setCountry(e: any) {
    if (e.target.value) {
      let selectCountryInfo = this.countriesList.find(c => c.name.toLowerCase() === e.target.value.toLowerCase());
      this.billingForm.get('country').setValue(selectCountryInfo);
      if (selectCountryInfo && selectCountryInfo.alpha2code) {
        this.countryChanged = false;
        this.options = {
          types: [],
          componentRestrictions: { country: selectCountryInfo.alpha2code }
        };
        setTimeout(() => { this.countryChanged = true });
      }
    }
  }

  getTicketsByEventId() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "timezone": this.timezoneVal
      }
    }
    let streamId = this.getParam('stream_id');
    let userId = this.getParam('user_id');
    this.getCurrencytype = this.getCurrency ? this.getCurrency : this.currentLocation.currency.code;
    let url = CONST_AWS_API.GET_TICKETS_BY_EVENT_ID + '/' + streamId + '/' + new Date().getTimezoneOffset() + '/' + this.getCurrencytype + '/' + userId
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.status == 200) {
        this.ticketsData = response['data']['Data'];
        let ticketIdInv: any = [], ids;
        ids = this.getParam('ticket_ids');
        if (ids && ids.includes(','))
          this.getTicketIds = ids.split(',');
        else
          this.getTicketIds.push(ids);
        this.ticketsData.forEach(element => {
          this.getTicketIds.forEach(ticketId => {
            if (element.id == ticketId) {
              if (element.shipping_address == 1)
                this.showShippingForm = true;
              let inv = { 'id': element.id, 'limited_tickets': element.limited_tickets }
              ticketIdInv.push(inv);
              if (element.sessions && element.sessions.length > 0) {
                element.sessions.forEach(e => {
                  this.ticketIds.push(e);
                });
              } else {
                if (!this.ticketIds.includes(element.event_id)) {
                  this.ticketIds.push(element.event_id);
                }
              }
            }
          });
          this.getTicketIdInv = ticketIdInv;
        });
      }
    }, error => {
      console.log(error);
    })
  }

  getParam(param) {
    try {
      let url = decodeURIComponent(location.href).split("?");
      let queryParams = url[1].split("&");
      let params = {};
      if (queryParams && queryParams.length > 0) {
        queryParams.forEach(p => {
          let p1 = p.split("=");
          params[p1[0]] = p1[1];
        });
      }
      return params[param];
    } catch (e) {
      console.log(e);
      return this.activatedRoute.snapshot.queryParamMap.get(param);
    }
  }

  ticket_key: any;

  prepare() {
    if (this.activatedRoute.snapshot.params.token) {
      this.ticket_key = this.getParam('ticket_key');
      this.streamId = this.getParam('stream_id');

      this.getQuestionsData = this.getParam('questions');
      this.paymentType = this.activatedRoute.snapshot.params.token;
      this.paymentData = {
        paymentType: this.paymentType,
        stream_id: this.getParam('stream_id'),
        user_id: this.getParam('user_id'),
        performer_id: this.getParam('performer_id'),
        organization_id: this.getParam('organization_id'),
        charity_id: this.getParam('charity_id'),
        guest_id: this.getParam('guest_id'),
        guest_first_name: this.getParam('guest_first_name'),
        guest_last_name: this.getParam('guest_last_name'),
        questions: this.getQuestionsData,
        ticket_ids: this.ticketIds,
        tickets: this.getTicketIdInv
      };

      this.getUserInfo(() => {
        this.getStreamInfo((streamInfo) => {
          this.getPaymentDetails(streamInfo);
        });
      });
      this.getTicketsByEventId();
    } else {
      // this.getToken();
      this.userInfo = JSON.parse(JSON.stringify(this.commanSubscribeService.userInfo));
      this.paymentData = this.commanSubscribeService.paymentInfo;
      this.getPaymentDetails(this.userService.liveEvents);
      console.log(this.userInfo);
    }
    if (this.currentLocation) {
      this.countriesList.forEach(country => {
        if (country.alpha2code == this.currentLocation.country_code2) {
          this.countryChanged = false
          this.billingForm.patchValue({
            country: country
          });
          // this.shippingForm.patchValue({
          //   country: country
          // });
          this.options = {
            types: [],
            componentRestrictions: { country: country.alpha2code }
          };
          this.checkState(country);
          setTimeout(() => { this.countryChanged = true });
        }
      });
    }
  }

  buildBillingForm() {
    this.billingForm = this.formBuilder.group({
      amount: ["", Validators.required],
      address1: ["", Validators.required],
      address2: [""],
      city: ["", Validators.required],
      state: ["", Validators.required],
      country: ["", [Validators.required, ValidationService.autoCompleteValueSelected(this.countriesList, 'name')]],
      zip: ["", Validators.required],
      athlete: ["", Validators.required]
    });

    // this.billingForm.valueChanges.subscribe(val => {
    //   // if (val.zip && this.currency == 'USD') {
    //   //   this.getTaxPercentage(val.zip);
    //   // }
    //   this.isStateOptional = false;
    //   this.billingForm.valueChanges.subscribe(val => {
    //     if (val.country && val.country.toLowerCase() == 'united kingdom' && !this.isStateOptional) {
    //       this.isStateOptional = true;
    //       this.billingForm.get("state").setValidators([]);
    //       this.billingForm.get("state").updateValueAndValidity();        
    //     }
    //   });
    // });
  }

  buildShippingForm() {
    this.shippingForm = this.formBuilder.group({
      address1: ['', Validators.required],
      address2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', [Validators.required, ValidationService.autoCompleteValueSelected(this.countriesList, 'name')]],
      zip: ['', Validators.required],
    });
  }

  buildCCForm() {
    this.ccForm = this.formBuilder.group({
      nameOnCard: ["", Validators.required],
      cardNumber: ["", Validators.required],
      expDate: ["", Validators.required],
      cvv: ["", Validators.required],
      month: [""],
      year: [""]
    });

    // this.ccForm.valueChanges.subscribe(val => {
    //   if (val.zip && this.currency == 'USD') {
    //     this.getTaxPercentage(val.zip);
    //   }
    // });
  }

  displayCountryName(option) {
    return option ? option.name : undefined;
  }

  filterCountry() {
    if (this.getBillingValue.country) {
      let countriesList = JSON.parse(JSON.stringify(COUNTRIES_LIST));
      const filterValue = this.getBillingValue.country.toLowerCase();
      this.countriesList = countriesList.filter(option => option.name.toLowerCase().indexOf(filterValue) >= 0);
    } else {
      this.countriesList = [];
    }
  }

  getToken() {
    this.paymentData = this.commanSubscribeService.paymentInfo;
    this.paymentInfoSubscription = this.commanSubscribeService.getPaymentInfo().subscribe(response => {
      this.paymentData = response;
    });
    this.userInfo = this.commanSubscribeService.userInfo;
    let data = this.getAwsData(this.paymentData);
    data.body.token = this.userInfo.session_token;
    console.log(this.userInfo)
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.PROCEED_TO_PAYMENT, data).then(result => {
      result = result.data;
      this.loader.stop();
      if (result['token']) {
        this.getPaymentDetailToken = result['token'];
        // this.getPaymentDetails();
      } else {
        this.toastr.error("Server Error");
      }
    }).catch(error => {
      this.loader.stop();
      if (error.error == "Unauthorized" || error.status == 401) {
        const dialogRef = this._matDialog.open(ConsumerSignInComponent, {
          width: "26%",
          panelClass: "app-consumer-sign-in",
          disableClose: true,
          data: { url: this.paymentData.redirectUrl }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result == "yes") {
          }
        });
      }
      console.log(error);
    });
  }

  getTaxPercentage(zip, callback) {
    let amount = this.getBillingValue.amount;
    if (this.paymentType == 'pay_per_view') {
      amount = this.streamInfo.amount;
    }
    if (this.paymentType == 'pay_per_view') {
      let data: any = {
        amount: amount,
        stream_id: this.streamId,
        payment_type: this.paymentType,
        currency: this.currency,
        address: {
          street1: this.getBillingValue.address1,
          city: this.getBillingValue.city,
          state: this.getBillingValue.state,
          state_code: this.codes.state,
          zip: this.getBillingValue.zip,
          country: this.getBillingValue.country.name,
          country_code: this.codes.country
        }
      };
      if (this.streamInfo.stream_vod == 'vod' || this.streamInfo.end_date_time) {
        data.vod = true;
      }
      if (this.streamInfo.vod_video_audio == 'audio') {
        data.vod_video_audio = 'audio';
      }
      this.paymentService.calculateTax(data, (result) => {
        if (result.status == 0) {
          this.taxPercentage = result.data.taxPercentage;
          this.taxAmount = result.data.tax;
          this.finalAmount = result.data.finalAmount;
          this.invoice_id = result.data.invoice_id;
          this.incl = result.data.incl;
          callback();
        } else {
          this.toastr.error('Unable to get tax');
        }
      });
    } else {
      this.taxPercentage = 0;
      this.taxAmount = 0;
      this.finalAmount = amount;
      this.invoice_id = '';
      this.incl = '';
      this.cd.detectChanges();
      callback();
    }
  }

  // getActiveTabData(activeTab) {
  //   this.paymentMode = activeTab.tab['textLabel'];
  //   // this.totalAmount = '';
  // }
  getSelectedAddress(val, type) {
    var myAddress = {
      name: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      country: '',
      zip: '',
      copy: false
    };
    let street = val && val.formatted_address ? val.formatted_address.split(',') : val.split(',');
    this.address = street[0];
    this.loader.start();
    if (val && val.formatted_address)
      val = val.formatted_address
    else
      val = this.pastedText;
    myAddress.address1 = this.address;
    if (val) {
      // let data = { address: val }
      // AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_ADDRESS, this.getAwsData(data)).then(result => {
      // result = result.data;  
      this.commanSubscribeService.getAddress(val, (result) => {
        this.loader.stop();
        if (result) {
          let place = {
            address_components: result['results'][0]['address_components'],
            geometry: result['results'][0].geometry
          }
          if (place && place.address_components) {
            place.address_components.forEach(element => {
              if ((element.types[0] == "sublocality_level_1" || element.types[0] == "premise") && element.long_name)
                myAddress.address2 = element.long_name;

              if ((element.types[0] == "locality" || element.types[0] == "postal_town") && element.long_name)
                myAddress.city = element.long_name;
              if ((element.types[0] == "administrative_area_level_1" || element.types[0] == "administrative_area_level_2") && element.long_name)
                myAddress.state = element.long_name;
              if (element.types[0] == "country" && element.long_name)
                myAddress.country = element.long_name;
              if (element.types[0] == "postal_code" && element.long_name)
                myAddress.zip = element.long_name;
            });
          }
          this.getBillingAddress(myAddress, type);
          // if (type == 'billingForm') {
          //   this.billingForm.patchValue({
          //     address1: myAddress.address1 ? myAddress.address1 : this.address,
          //     address2: myAddress.address2,
          //     city: myAddress.city,
          //     state: myAddress.state,
          //     // country: myAddress.country,
          //     zip: myAddress.zip
          //   });
          // }

        }
      });
      // }).catch((error)=>{
      //   this.loader.stop();
      // });
    }
  }

  getBillingAddress(myAddress, formType, val?) {
    let formVal = formType == 'billingForm' ? this.billingForm : this.shippingForm;
    let country = myAddress.country && val ? COUNTRIES_LIST.find(c => c.name === myAddress.country.name) : COUNTRIES_LIST.find(c => c.name === myAddress.country);
    formVal.patchValue({
      address1: myAddress.address1 ? myAddress.address1 : this.address,
      address2: myAddress.address2,
      city: myAddress.city,
      state: myAddress.state,
      country: country ? country : {},
      zip: myAddress.zip
    });
  }

  populateBillingAddress(event) {
    console.log(event);
    console.log(this.shippingForm.value);
    if (event.checked)
      this.getBillingAddress(this.shippingForm.value, 'billingForm', true);
    else
      this.buildBillingForm();
  }

  onPasteLocation(event: ClipboardEvent, form) {
    let clipboardData = event.clipboardData || window.clipboardData;
    this.pastedText = clipboardData.getData('text');
    this.getSelectedAddress(this.pastedText, form);
  }
  // checkInfo(formValid) {
  //   if (formValid) {
  //     var currentYear = parseFloat(new Date().getFullYear().toString().substr(2, 2));
  //     var currentMonth = new Date().getMonth() + 1;
  //     var month = this.getCCValue.month;
  //     var year = this.getCCValue.year;
  //     if (currentYear == year && currentMonth <= month) {
  //       this.completePayment();
  //     } else if (currentYear < year && (currentMonth <= month || currentMonth >= month)) {
  //       this.completePayment();
  //     } else {
  //       this.toastr.error('Credit card expired');
  //     }
  //   }
  // }

  getSubscription(stream_info, callback) {
    console.log(this.userInfo);
    if (this.paymentType == 'pay_per_view') {
      this.paymentService.getSubscriptionStatus(this.userInfo, stream_info, (subscriptionStatus: any) => {
        callback(subscriptionStatus);
      });
    } else {
      callback(false);
    }
  }

  creator_currency: any;
  charity_currency: any;
  streamUrl: any;
  affiliateInfo: any;

  getPaymentDetails(streamInfo) {
    this.paymentType = this.paymentData.paymentType;
    const performerInfo = this.commanSubscribeService.perfomerInfoData?.data?.Data[0];
    if (streamInfo.referrer_code) {
      let info = streamInfo.beforeReplace_stream_info;
      if (info && info.affiliates && info.affiliates.length > 0) {
        let aff = info.affiliates.filter(a => a.referral_code == streamInfo.referrer_code);
        if (aff.length > 0) {
          this.affiliateInfo = aff[0];
        }
      }
    }

    if (streamInfo.user_subscription_info && streamInfo.user_subscription_info.length > 0 && streamInfo.affiliates && streamInfo.affiliates.length > 0) {
      let info = streamInfo.user_subscription_info[0];
      let aff = streamInfo.affiliates.filter(a => a.referral_code == info.referrer_code);
      if (aff.length > 0) {
        this.affiliateInfo = aff[0];
      }
    }
    let stream = streamInfo.stream_info;
    this.commonSubscribeService.sendSlugData(stream);
    const settings = stream?.settings_json;

    if (typeof settings === "string" && settings.trim() !== "") {
      try {
        this.settingsJSON = JSON.parse(settings);
      } catch (e) {
        console.error("Invalid JSON:", settings, e);
        this.settingsJSON = {};
      }
    } else if (typeof settings === "object") {
      this.settingsJSON = settings;
    } else {
      this.settingsJSON = {};
    }

    //this.settingsJSON = JSON.parse(stream?.settings_json);
    if (stream?.stream_status == 'pending' || stream?.stream_status == 'progress') {
      this.streamUrl = environment.CONSUMER_PORTAL + 'event/stream/' + this.ticket_key + '?stage=' + stream?.id;
    } else {
      this.streamUrl = environment.CONSUMER_PORTAL + 'event/watch/' + this.ticket_key + '?stage=' + stream?.id;
    }
    this.getSubscription(stream, (subscriptionStatus) => {
      // var ctDate,currentDate,displayAmounts;
      // displayAmounts = stream.stream_amounts ? JSON.parse(stream.stream_amounts) : [];
      // ctDate = moment().format("YYYY-MM-DD");
      // currentDate = new Date(ctDate).getTime();
      // displayAmounts = this.router.url.includes('watch') ? displayAmounts['vod'] : displayAmounts['live_stream'];
      // if (displayAmounts && displayAmounts.length>0) {
      //   displayAmounts.forEach(element => {
      //     if (element.booking_start_date) {
      //       let bookingStartTime = moment.utc(element.booking_start_date).toDate();
      //       let startTime = moment(bookingStartTime).format('YYYY-MM-DD');
      //       let bst = new Date(startTime).getTime();
      //       let bookingEndTime = moment.utc(element.booking_end_date).toDate();
      //       let endTime = moment(bookingEndTime).format('YYYY-MM-DD');
      //       let bet = new Date(endTime).getTime();
      //       if (bst <= currentDate && currentDate <= bet) {
      //         element.amounts.forEach(e => {
      //           if (e.currency_type == 'USD')
      //             this.USDAmount.push(e);
      //           else
      //             this.GBPAmount.push(e);
      //         });
      //         if (stream.currency_type == 'USD') {
      //           this.USDAmount.forEach(element => {
      //             this.getAmount = JSON.parse(element.stream_payment_amount);
      //             this.amount = this.getAmount.toFixed(2);
      //           });
      //         } else {
      //           this.GBPAmount.forEach(element => {
      //             this.getAmount = JSON.parse(element.stream_payment_amount);
      //             this.amount = this.getAmount.toFixed(2);
      //           });
      //         }
      //         if (this.paymentType == "pay_per_view") {
      //           this.billingForm.patchValue({
      //             amount: this.amount
      //           });
      //         }
      //       }
      //     }
      //   });
      // }
      let performer = streamInfo.performer_info ? streamInfo.performer_info : this.commanSubscribeService.perfomerInfoData;


      let resKey = 'stream';
      let resObj: any = {};
      if (!this.paymentData.organization_id) {
        this.paymentData.organization_id = stream?.organization_id;
      }

      resObj.stream = {
        id: this.paymentData.stream_id,
        stream_video_title: stream?.stream_video_title,
        organization_id: stream?.organization_id ? stream.organization_id : this.paymentData.organization_id,
        amount: this.getAmount,
        currency: stream?.currency_type,
        stream_amounts: stream?.stream_amounts,
        publish_date_time: stream?.publish_date_time,
        video_thumbnail_image: stream?.video_thumbnail_image,
        video_banner_image: stream?.video_banner_image,
        performer_id: stream?.performer_id ? stream.performer_id : this.paymentData.performer_id,
        user_first_name: stream?.user_first_name ? stream.user_first_name : performerInfo?.performer_details.performer_display_name,
        user_last_name: stream?.user_last_name ? stream.user_last_name : performerInfo?.performer_details.performer_display_name,
        user_display_name: stream?.user_display_name ? stream.user_display_name : performerInfo?.performer_details.performer_display_name,
        channel_name: stream?.channel_name ? stream.channel_name : performerInfo?.channel_name,
        number_of_creators: stream?.number_of_creators,
        stream_status: stream?.stream_status,
        currency_type: stream?.currency_type,
        expected_end_date_time: stream?.expected_end_date_time,
        event_id: stream?.parent_streams_id,
        vod_video_audio: stream?.vod_video_audio,
      };
            this.creator_currency = stream?.currency_type;

      if (this.paymentData.paymentType == 'charity_donation' && this.paymentData.charity_id && this.paymentData.stream_id) {
        let charities = streamInfo.charity_info || [];
        let charity: any = {};
        for (let i = 0; i < charities.length; i++) {
          if (charities[i].id == this.paymentData.charity_id) {
            charity = charities[i];
          }
        }
        resKey = 'charity';
        this.charity_currency = charity.charity_currency;
        resObj.charity = {
          id: charity.id, charity_name: charity.charity_name, charity_description: charity.charity_description, currency: charity.charity_currency,
          charity_logo: charity.charity_logo, organization_id: charity.organization_id, organization_name: performer.organization_name
        };
        resObj.performer = { id: performer?.user_id, performer_name: performer?.performer_display_name, organization_id: stream?.organization_id, organization_name: performer?.organization_name, currency: stream?.currency_type };
      } else if (this.paymentData.paymentType == 'performer_tip' || this.paymentData.paymentType == 'community_tip') {
        resKey = 'performer';
        resObj.performer = { id: performer?.user_id, performer_name: performer?.performer_display_name, organization_id: stream?.organization_id, organization_name: performer?.organization_name, currency: stream?.currency_type };
        if (!this.paymentData.performer_id) {
          this.paymentData.performer_id = stream.performer_id;
        }
      }
      if (this.paymentData.guest_id) {
        resObj[resKey].guest_id = this.paymentData.guest_id;
        // if (stream.creators) {
        //   for (let i=0; i< stream.creators.length; i++) {
        //     if (stream.creators[i].id == this.paymentData.guest_id) {
        //       resObj[resKey].first_name = this.paymentData.guest_first_name = stream.creators[i].first_name;
        //       resObj[resKey].last_name = this.paymentData.guest_last_name = stream.creators[i].last_name;;
        //       resObj[resKey].performer_name = this.paymentData.guest_first_name + ' ' + this.paymentData.guest_last_name;
        //     }
        //   }
        // }
        resObj[resKey].first_name = this.paymentData.guest_first_name;
        resObj[resKey].last_name = this.paymentData.guest_last_name;
        resObj[resKey].performer_name = this.paymentData.guest_first_name + ' ' + this.paymentData.guest_last_name;
      }
      resObj.status = 0;
      resObj.message = "Success";
      resObj.paymentType = this.paymentData.paymentType;
      resObj.redirectUrl = this.paymentData.redirectUrl || '';
      resObj.stream_id = this.paymentData.stream_id;
      this.streamId = resObj.stream_id;
      // this.psKey = result['ps_key'];
      // this.userInfo = resObj.user || {};
      if (!resObj.redirectUrl) {
        // let data = {
        //   access_token: this.userInfo.access_token || this.getPaymentDetailToken
        // }
        // this.commanSubscribeService.sendUserInfo(data);
      }


      this.streamInfo = resObj.stream || {};

      this.paymentType = resObj.paymentType;

      if (this.streamInfo && this.paymentType == "pay_per_view" && this.currentLocation) {
        let result = this.commonSubscribeService.getAmount(stream, this.currentLocation, subscriptionStatus, this.ticketsData);
        // if (result && result.current) {
        console.log(result.currectDatesAmounts);
        // if (result && result.currectDatesAmounts && result.currectDatesAmounts.length > 0) {
        // this.currectDatesAmounts = result.currectDatesAmounts;
        let amount, defaultAmount, totalAmount = 0;
        this.ticket_type_name = this.getParam('ticket_type_name');
        this.ticketsData.forEach(element => {
          this.getTicketIds.forEach(ticketId => {
            if (element.id == ticketId) {
              // if (element.ticket_type_name.toLowerCase() == this.ticket_type_name.toLowerCase()) {
              // element.amounts.forEach(e => {
              //   if (e.currency_type == this.currentLocation.currency.code) {
              //     amount = e;
              //   }
              //   if (e.is_default) {
              //     defaultAmount = e;
              //   }
              // });
              totalAmount += element.price;
              amount = element;
            }
            // amount = amount || defaultAmount;
            // }
          });
        });
        if (amount) {
          this.amount = totalAmount;
          this.currency = amount.currency;
          this.streamInfo.currency = amount.currency;
          this.streamInfo.amount = totalAmount;
          this.finalAmount = totalAmount;
          this.billingForm.patchValue({
            amount: this.amount
          });
          if (this.activatedRoute.snapshot.queryParams.discount_code && this.getParam('discount_code')) {
            this.promoCode = this.getParam('discount_code');
            this.verifyCode();
          }
          // this.amount = amount.stream_payment_amount;
          // this.currency = amount.currency_type;
          // this.streamInfo.currency = amount.currency_type;
          // this.streamInfo.amount = amount.stream_payment_amount;
          // this.finalAmount = amount.stream_payment_amount;
          this.billingForm.get("amount").disable();

        } else {
          this.toastr.error("Ticket not found");
        }
        // this.amount = result.current.price;
        // this.currency = result.current.currency;
        // this.streamInfo.currency = result.current.currency;
        // this.streamInfo.amount = result.current.price;
        // this.finalAmount = result.current.price;
        // } else {
        //   let message = result.message || 'Something went wrong';
        //   this.toastr.error(message);
        // }
        // let stream_amounts = displayAmounts;
        // let foundCurrency: any = "";
        // stream_amounts.forEach(ele => {
        //   ele.amounts.forEach(e => {
        //     if (this.currentLocation.country_name && this.currentLocation.currency && e.currency_type && e.country_name
        //       && e.currency_type == this.currentLocation.currency.code && e.country_name == this.currentLocation.country_name) {
        //       foundCurrency = e;
        //     }
        //   });
        // });

        // if (foundCurrency) {
        //   this.streamInfo.currency = foundCurrency.currency_type;
        //   this.streamInfo.amount = foundCurrency.stream_payment_amount;
        // }

        // if (this.streamInfo.currency) {
        //   this.currency = this.streamInfo.currency;
        // }
        // this.finalAmount = this.streamInfo.amount;
      }



      if (this.paymentType == "charity_donation") {
        this.charityInfo = resObj.charity || {};
        this.performerInfo = resObj.performer || {};
        this.streamInfo.organization_id = this.charityInfo.organization_id;
        this.currency = this.currency ? this.currency : this.charityInfo.currency;
        let stage_id = this.getParam('stage_id') || this.streamInfo.id;
        this.streamInfo.id = stage_id;
        this.streamInfo.currency = this.charityInfo.currency;
        // this.taxable = false;
      } else if (this.paymentType == "performer_tip" || this.paymentType == "community_tip") {
        this.performerInfo = resObj.performer || {};
        this.streamInfo.organization_id = this.performerInfo?.organization_id ?
          this.performerInfo.organization_id : this.paymentData.organization_id;
        this.currency = this.currency ? this.currency : this.performerInfo.currency ? this.performerInfo.currency : 'USD';
        let stage_id = this.getParam('stage_id') || this.streamInfo.id;
        this.streamInfo.id = stage_id;
        this.groupName = this.resolveGroupName(stream?.network_group_id);
        // this.taxable = false;
      }

      // this.currentLocation.currency.code = 'GBP';
      if (this.paymentType == "charity_donation" || this.paymentType == "performer_tip" || this.paymentType == "community_tip") {
        if (this.currentLocation.currency.code == 'USD' || this.currentLocation.currency.code == 'GBP') {
          this.currency = this.currency ? this.currency : this.currentLocation.currency.code;
        }
      }
      this.buildCCForm();
      // if (this.taxable) {
      let amount = this.finalAmount;
      if (amount) {
        amount = parseFloat(amount).toFixed(2);
      }
      if (this.paymentType == 'pay_per_view') {
        this.billingForm.patchValue({
          amount: amount
        });
        this.billingForm.get("amount").disable();
        // this.billingForm.get("amount").setValidators([Validators.required]);
        // this.billingForm.get("amount").updateValueAndValidity();
      }
      // }
      if (resObj.redirectUrl) {
        this.redirectUrl = resObj.redirectUrl;
      }


      this.getCurrencyRates(this.streamInfo.currency);
    });
  }

  // Tip success message shows the group name instead of the performer name
  // when the tip was sent from within a group's community space. The groups
  // list (id -> group_name) is already loaded app-wide via GET_PERFORMER_INFO,
  // so this resolves locally rather than issuing another API call.
  resolveGroupName(networkGroupId): string {
    if (!networkGroupId) {
      return '';
    }
    const groups = this.commanSubscribeService.perfomerInfoData?.data?.Data?.[0]?.groups || this.commanSubscribeService.groups || [];
    const matchedGroup = groups.find((g: any) => g.id == networkGroupId);
    return matchedGroup ? (matchedGroup.name || '') : '';
  }

  getCurrencyRates(currency) {
    if (this.currency == 'USD' || this.currency == 'GBP') {
      currency = this.currency;
    }
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }

    let url = CONST_AWS_API.GET_EXCHANGE_RATES + '/' + currency;
    // this.loader.start();
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        // this.loader.stop();
        this.rates = response['data']['Data']['rates'];
        // Set conversionRate here directly off this.currency (already resolved with a fallback
        // by the time this runs) rather than only inside the currentLocation branch below —
        // for flows like community_tip, currentLocation isn't reliably populated by this point,
        // which left conversionRate (and the recommended-tips buttons gated on it) never set.
        this.conversionRate = this.rates[this.currency] || this.conversionRate;

      }
      if (this.currentLocation && this.currentLocation.currency) {
        this.currenciesList.forEach(element => {
          let getVal = element.split(' -');
          let getCode = this.currentLocation.currency.code.includes('\"') ? JSON.parse(this.currentLocation.currency.code) : this.currentLocation.currency.code;
          let currencyType = this.getCurrency ? this.getCurrency : getCode;
          if (getVal[0] == currencyType) {
            this.currencyVal = element;
            let val = this.currencyVal.split(' -');
            if (this.curWithoutDecimals.includes(val[0])) {
              this.allowDecimals = false;
            } else {
              this.allowDecimals = true;
            }
            this.currency = getVal[0];
            this.storageService.setItem('currency', getVal[0]);
            Object.keys(this.rates).forEach(rates => {
              if (this.currency == rates) {
                // Matches the 2.5% conversion markup already applied to the wallet's own
                // "1 $ equivalent to ..." figure (payment-transactions.component.ts's convRate)
                // - without it, this minimum-amount figure understates the wallet's by ~2.5%.
                this.minAmount = Number((this.rates[rates] * 1.025).toFixed(2));
              }
            })
            // this.commonSubscribeService.sendCurrencyInfo(getVal[0]);
            this.conversionRate = this.rates[this.currency];
          }
        });
      }
      console.log(this.getCurrency, this.streamInfo.currency);
    }).catch(error => {
      this.loader.stop();
    });
  }

  // closeMenu(){
  //   this.commanSubscribeService.sendPaymentInfo('closeMenu');
  // }

  verifyCode() {
    let url = CONST_AWS_API.VERIFY_CODE;
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        'stream_id': this.streamInfo.id,
        'code': this.promoCode
      }
    }
    AWS_API.post(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.status == 200 && response['data']['message'] == "Success") {
        let discountInfo = response['data']['Data'][0] || {};
        this.finalAmounts(discountInfo);
      } else {
        this.toastr.error(response['data']['message']);
      }
    }, error => {
      console.log(error);
    })
  }

  totalAmountAfterDiscount: any;
  discountVal = 0;
  discountInfo: any = {};
  finalAmounts(discountInfo) {
    this.discountInfo = discountInfo || {};
    let discount = discountInfo.discount;
    let val = this.amount * (discount / 100);
    this.discountVal = val;
    this.streamInfo.amount = this.finalAmount = this.amount = this.totalAmountAfterDiscount = (this.amount - val).toFixed(2);
    this.billingForm.patchValue({
      amount: this.amount
    });
  }

  proceed() {
    if (!this.isAgrees && this.paymentType == 'pay_per_view') {
      this.toastr.error('Please accept terms and conditions');
      return;
    }
    if (this.shippingForm.invalid && this.showShippingForm)
      this.toastr.error('Please enter complete shipping address');
    if ((this.billingForm.invalid && this.getBillingValue.zip == '') && (Object.keys(this.selectedCard).length == 0 && (this.selectedBillingAddress && Object.keys(this.selectedBillingAddress).length == 0))) {
      this.toastr.error('Please enter complete billing address');
      return;
    }
    else if (this.getBillingValue.amount == '') {
      this.toastr.error('Please enter amount');
      return;
    }
    if (this.billingForm.valid || ((this.selectedCard && this.selectedCard.id) || (Object.keys(this.selectedBillingAddress).length > 0) || this.billingForm.valid)) {
      console.log(this.currency);
      //if (this.currency != 'USD') { 19-10-2021 disabled paystand
      //} 19-10-2021 disabled paystand
      Object.keys(window).forEach((key) => {
        if (/paypal|zoid|post_robot/.test(key)) {
          // eslint-disable-next-line fp/no-delete
          delete window[key];
        }
      });

      if (this.selectedCard && this.selectedCard.id) {
        let card = this.selectedCard.billing_address;
        this.selectedBillingAddress.line1 = card.line1;
        this.selectedBillingAddress.line2 = card.line2;
        this.selectedBillingAddress.city = card.city;
        this.selectedBillingAddress.country = card.country;
        this.selectedBillingAddress.state = card.state;
        this.selectedBillingAddress.zip = card.postal_code;
      }
      let country;
      if (this.selectedCard && this.selectedCard.id) {
        COUNTRIES_LIST.forEach(element => {
          if (element.alpha2code == this.selectedCard.billing_address.country) {
            country = element;
          }
        });
      }
      let zip = this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : "";
      let cName = this.getBillingValue.country.name ? this.getBillingValue.country.name : this.selectedBillingAddress && this.selectedBillingAddress.country ? country ? country.name : this.selectedBillingAddress.country : ""
      // this.validateZip((valid) => {
      this.commanSubscribeService.validateZip(zip, cName, (result) => {

        if (result.status) {
          this.getPaymentData.emit(true);
          this.backToHome = false;
          this.codes = result;
          let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.codes.country)
          this.codes.country = country[0].alpha3code;
          this.getTaxPercentage(zip, () => {
            this.showCCForm = true;
            if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1) {
              this.finalAmount = Number(this.finalAmount);
              this.processingFee = (this.finalAmount * (environment.processing_fee / 100)) + environment.fee_percentage;
              this.finalAmount += this.processingFee;
            }
          });
        } else {
          this.toastr.error('Invalid zip code');
        }
      });
    }
  }

  formatMonth() {
    var expDate = this.getCCValue.expDate;
    if (expDate) {
      this.ccForm.get('month').setValue(expDate.substr(0, 2));
      this.ccForm.get('year').setValue(expDate.substr(2, 2));
      this.ccForm.get('expDate').setValue(expDate.substr(0, 2) + "/" + expDate.substr(2, 2));
    }
  }

  calFee(response) {
    if (this.activeBlock == "Tips" || this.activeBlock == "Donations") {
      this.selectedTransaction = response.selectedTransaction;
      let amount = this.getBillingValue && this.getBillingValue.amount ? this.getBillingValue.amount : 0;
      if (this.selectedTransaction == "wallet" || this.selectedTransaction == "crypto") {
        this.processingFee = 0;
        this.finalAmount = Number(amount);
      } else if (this.selectedTransaction && this.selectedTransaction == "ott") {
        this.processingFee = 0;
        if (this.settingsJSON?.fee_to_fan == 1) {
          this.processingFee = (amount * (environment.processing_fee / 100)) + environment.fee_percentage;
          this.processingFee = Number(this.processingFee.toFixed(2));
        }
        this.finalAmount = Number(amount) + this.processingFee;
      }
      let data = {
        "total_amount": this.finalAmount,
        "currency": this.currency,
        "processing_fee": this.processingFee ? this.processingFee : undefined,
        "amt_without_pf": Number(amount)
      }
      this.commonSubscribeService.totalAmountSubject.next(data);
    }
  }

  amountChange(value) {
    // if(this.selectedTransaction){
    //   this.userInfo.close_modal = true;
    //   this.commonSubscribeService.userDetailSubject.next(this.userInfo);
    //   this.commonSubscribeService.formsValidationSubject.next(false);
    //   return;
    // }
    if (this.minAmount)
      this.minAmount = Number(this.minAmount.toFixed(2));
    if (value != "" && Number(value) < Number(this.minAmount)) {
      this.billingForm.patchValue({
        amount: ''
      });
      let data = {
        "price": this.minAmount,
        "currency": this.currency
      }
      this.commanSubscribeService.getCurPrice(data, result => {
        this.toastr.error('Minimum required amount is ' + result);
      });
      this.userInfo.close_modal = true;
      this.commonSubscribeService.userDetailSubject.next(this.userInfo);
      this.commonSubscribeService.formsValidationSubject.next(false);
    }
    else if (value != '') {
      let amount = parseFloat(value);
      this.finalAmount = amount + (amount * this.taxPercentage);
      if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1) {
        this.finalAmount = Number(this.finalAmount);
        this.processingFee = (this.finalAmount * (environment.processing_fee / 100)) + environment.fee_percentage;
        this.finalAmount += this.processingFee;
      }
      if (this.isFromCommunityTips && !this.selectedAthleteDetails) {
        this.commonSubscribeService.formsValidationSubject.next(false);
      } else {
        this.commonSubscribeService.formsValidationSubject.next(true);
      }

      let data = {
        "total_amount": this.finalAmount,
        "currency": this.currency,
        "processing_fee": this.processingFee ? this.processingFee : undefined
      }
      this.commonSubscribeService.totalAmountSubject.next(data);
    } else {
      this.userInfo.close_modal = true;
      this.commonSubscribeService.userDetailSubject.next(this.userInfo);
      this.commonSubscribeService.formsValidationSubject.next(false);
    }
  }
  checkAmount(value) {
    //  match typed amount to recommended tips
    const matchedTip = this.channelDetails?.recommendedTips?.find(
      t => Number((t.value * this.conversionRate).toFixed(2)) === Number(value)
    );

    if (matchedTip) {
      this.selectedTip = matchedTip.value * this.conversionRate;
    } else {
      this.selectedTip = 0;
    }
    if (this.selectedTransaction) {
      this.userInfo.close_modal = true;
      this.commonSubscribeService.userDetailSubject.next(this.userInfo);
      this.commonSubscribeService.formsValidationSubject.next(true);
      return;
    }
    if (value != '') {
      if (this.isFromCommunityTips && !this.selectedAthleteDetails) {
        this.commonSubscribeService.formsValidationSubject.next(false);
      } else {
        this.commonSubscribeService.formsValidationSubject.next(true);
      }

    } else {
      this.userInfo.close_modal = true;
      this.commonSubscribeService.userDetailSubject.next(this.userInfo);
      this.commonSubscribeService.formsValidationSubject.next(false);
    }
  }
  get getCCValue() {
    return this.ccForm.getRawValue();
  }
  get getBillingValue() {
    return this.billingForm.getRawValue();
  }

  get getShippingValue() {
    return this.shippingForm.getRawValue();
  }

  validateZip(callback) {
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.VALIDATE_ZIP, this.getAwsData({ zip: this.getBillingValue.zip, country: this.getBillingValue.country.name })).then(result => {
      this.loader.stop();
      result = result.data;
      this.codes = result.codes;
      callback(result.status);
    }).catch((err) => {
      this.loader.stop();
    });
  }

  completePayment(id, gateway) {
    this.toggleLoader('block');
    // this.loader.start();
    // this.validateZip((valid) => {
    //   if (valid) {
    var paymentInfo: any = {
      paymentType: this.paymentType,
      payment_type: this.paymentType,
      organization_id: this.streamInfo ? this.streamInfo.organization_id : '',
      currency: this.getCurrency || "USD",
      gateway: gateway
      // subscription_id: this.subscriptionInfo.id ? this.subscriptionInfo.id : '',
    }
    if (this.paymentType == 'performer_tip' || this.paymentType == 'community_tip') {
      paymentInfo.performer_id = JSON.stringify(this.performerInfo.id);
      paymentInfo.amount = paymentInfo.finalAmount = this.finalAmount;
      paymentInfo.stream_id = JSON.stringify(this.performerInfo.stream_id);
    } else if (this.paymentType == 'charity_donation') {
      paymentInfo.amount = paymentInfo.finalAmount = this.finalAmount;
      paymentInfo.charity_id = this.charityInfo.id;
      paymentInfo.performer_id = JSON.stringify(this.performerInfo.id);
      paymentInfo.stream_id = this.charityInfo.stream_id;
    } else {
      paymentInfo.amount = this.streamInfo.amount;
      paymentInfo.finalAmount = this.finalAmount;
      paymentInfo.performer_id = JSON.stringify(this.performerInfo.id);
      paymentInfo.stream_id = JSON.stringify(this.streamInfo.id);
      paymentInfo.ticket_type_name = this.ticket_type_name;
      if (this.showShippingForm) {
        paymentInfo.shipping_address = {
          street1: this.getBillingValue.address1,
          city: this.getBillingValue.city,
          state: this.getBillingValue.state,
          state_code: this.codes.state,
          zip: this.getBillingValue.zip,
          country: this.getBillingValue.country.name,
          country_code: this.codes.country
        };
      }
      paymentInfo.tickets = this.getTicketIdInv;
      paymentInfo.ticket_ids = this.paymentData.ticket_ids;
      if (this.paymentData.questions)
        paymentInfo.questions = this.paymentData.questions;
    }
    paymentInfo.stream_id = this.streamId;

    // if (this.paymentMode == 'Credit Card') {
    //   let card = {
    //     nameOnCard: this.getCCValue.nameOnCard,
    //     cardNumber: this.getCCValue.cardNumber,
    //     month: this.getCCValue.month,
    //     year: 20 + this.getCCValue.year,
    //     cvv: this.getCCValue.cvv,
    //   }
    //   let address = {
    //     street1: this.address,
    //     city: this.getBillingValue.city,
    //     state: this.getBillingValue.state,
    //     zip: this.getBillingValue.zip,
    //     country: this.getBillingValue.country
    //   }
    //   paymentInfo.card = card;
    //   paymentInfo.billingAddress = address;
    // }

    // let data = {
    //   paymentInfo: paymentInfo,
    //   user_id: this.userInfo.id,
    //   first_name: this.userInfo.first_name,
    //   last_name: this.userInfo.last_name,
    //   email: this.userInfo.email,
    //   currency: this.currency
    // }
    // this.appPaymentService.getRequest(API.GET_PUBLIC_KEY).subscribe(result => {
    //   var encrypt = new JSEncrypt();
    //   encrypt.setPublicKey(result.key);
    // paymentInfo['card'] = encrypt.encrypt(JSON.stringify(paymentInfo['card']));
    paymentInfo['cardId'] = this.cardId;
    paymentInfo['country'] = this.getBillingValue.country.name;
    paymentInfo['country_code'] = this.currentLocation.country_code2;
    paymentInfo['exchange_rate'] = this.minAmount;
    if (this.paymentType == 'charity_donation' && this.charityInfo) {
      paymentInfo.toName = this.charityInfo.charity_name;
      if (this.streamInfo.event_id == 0 && this.getParam('stage_id')) {
        this.streamInfo.event_id = this.getParam('stream_id');
      }
    } else if ((this.paymentType == 'performer_tip' || this.paymentType == 'community_tip') && this.performerInfo) {
      paymentInfo.toName = this.performerInfo.performer_display_name;
    }
    paymentInfo.streamInfo = this.streamInfo;
    paymentInfo.guest_id = this.performerInfo.guest_id;
    paymentInfo['invoice_id'] = this.invoice_id;
    paymentInfo.cardId = id;
    paymentInfo.tax_amount = this.taxAmount;
    paymentInfo.tax_rate = this.taxPercentage;
    paymentInfo.address = {
      street1: this.getBillingValue.address1,
      city: this.getBillingValue.city,
      state: this.getBillingValue.state,
      state_code: this.codes.state,
      zip: this.getBillingValue.zip,
      country: this.getBillingValue.country.name,
      country_code: this.codes.country
    };

    if (this.paymentType == 'pay_per_view') {
      let formData = this.contactInfoForm.getRawValue();
      let users: any = [];
      if (formData && formData.contactList) {
        formData.contactList.forEach(e => {
          users.push({
            id: e.id,
            first_name: e.user_first_name,
            last_name: e.user_last_name,
            email: e.user_email
          })
        });
      }
      paymentInfo.users = users;
    }
    paymentInfo['fee_to_fan'] = this.settingsJSON.fee_to_fan;
    if (this.settingsJSON.fee_to_fan == 1) {
      paymentInfo['processing_fee_amount'] = this.processingFee;
      paymentInfo['processing_fee_percentage'] = environment.processing_fee;
      paymentInfo['processing_fee_fixed'] = environment.fee_percentage;
    }
    paymentInfo['creator_currency'] = this.paymentData.paymentType == 'charity_donation' ? this.charity_currency : this.creator_currency;
    this.paymentData.paymentType == 'charity_donation';
    document.getElementById('paymentSection').scrollIntoView({ behavior: 'smooth' });
    let url = API.MAKE_PAYMENT + "?NOLOADER";
    this.appPaymentService.postRequest(url, { paymentInfo: paymentInfo }).subscribe(result => {
      this.showOverlay = false;
      if (result.status == 0) {
        // this.isPaymentSuccess = true;
        this.toastr.success("Payment completed Successfully");
        if (this.redirectUrl) {
          this.paymentSuccess = true;
          if (this.paymentType == 'pay_per_view')
            this.afterPaymentSuccess.emit("payPerViewSuccess");
          // this.router.navigateByUrl(this.redirectUrl)
          // this.redirectToHome();
        } else {
          this.isPaymentSuccess = true;
        }
      } else {
        this.toastr.error(result.message);
      }
      this.showOverlay = false;
      this.toggleLoader('none');
    }, error => {
      setTimeout(() => {
        this.showOverlay = false;
      }, 500);
      this.toggleLoader('none');
      this.toastr.error(error.error);
    });
    // }, error => {
    //   this.toastr.error('Server error');
    // });
    //   } else {
    //     this.toastr.error('Invalid zip code');
    //   }
    // });
  }

  close(paymentType) {
    console.log("payment type ", paymentType);
    this.getPaymentData.emit(paymentType);
    if (this.dialogRef && typeof this.dialogRef.close === 'function') {
      this.dialogRef.close(paymentType);
    }

  }

  async makePayment(from?) {
    this.getCurrency = this.storageService.getItem('currency');
    const performerInfo = this.commanSubscribeService.perfomerInfoData?.data?.Data[0];
    const performer_display_name = performerInfo?.performer_details.performer_display_name;
    const organisationData = this.commanSubscribeService.paymentInfo.organisationNetworkData;
    const spaceDetails = this.commanSubscribeService.paymentInfo.spaceDetails;
    let amount, finalAmount, name;
    name = this.userInfo.user_display_name || this.userInfo.display_name
    if (this.paymentType == 'pay_per_view') {
      amount = this.streamInfo.amount;
      finalAmount = this.finalAmount;
    } else {
      amount = finalAmount = this.finalAmount;
    }
    if (this.transactionInfo["card"] || from == 'card' || this.transactionInfo["mode"]) {
      let data: any = {
        amount: this.selectedTransaction == "crypto" ? this.crypto_amount : amount,
        finalAmount: this.selectedTransaction == "crypto" ? this.crypto_amount : finalAmount,
        currency: this.transactionInfo.currency ? this.transactionInfo.currency : this.getCurrency.toLowerCase() || 'gbp',
        organization_id: this.streamInfo?.organization_id ? this.streamInfo.organization_id : this.commanSubscribeService.paymentInfo.organization_id,
        performer_id: this.performerInfo.id ? JSON.stringify(this.performerInfo.id) : this.commanSubscribeService.paymentInfo.performer_id,
        stream_id: this.streamInfo.id ? JSON.stringify(this.streamInfo.id) : this.commanSubscribeService.paymentInfo.stream_id,
        paymentType: this.paymentType,
        payment_type: this.paymentType,
        response: null,
        transaction_id: '',
        name: name,
      };
      data['exchange_rate'] = this.minAmount;
      data['zip'] = this.getBillingValue.zip;
      if (this.paymentType == 'charity_donation' && this.charityInfo) {
        data['toName'] = this.charityInfo.charity_name;
        data['stream_id'] = this.charityInfo.stream_id;
        data['charity_id'] = this.charityInfo.id;
        if (this.streamInfo.event_id == 0 && this.getParam('stage_id')) {
          this.streamInfo.event_id = this.getParam('stream_id');
        }
      } else if ((this.paymentType == 'performer_tip' || this.paymentType == 'community_tip') && this.performerInfo) {
        data['toName'] = this.performerInfo.performer_name ? this.performerInfo.performer_name : performer_display_name;
        if (this.streamInfo.event_id == 0 && this.getParam('stage_id')) {
          this.streamInfo.event_id = this.getParam('stream_id');
        }
      }
      data['guest_id'] = this.performerInfo.guest_id;
      data['invoice_id'] = this.invoice_id;
      data['tax_amount'] = this.taxAmount;
      data['tax_rate'] = this.taxPercentage;
      data['stream_id'] = this.streamId;
      data['streamInfo'] = this.streamInfo;
      data['charity_id'] = this.charityInfo.id;
      data['country'] = this.getBillingValue.country.name;
      data['org_info'] = organisationData;
      if (this.selectedAthleteDetails) {
        data['pubNubUserId'] =
          this.selectedAthleteDetails.pubNubUserId;
        data['space_info'] = spaceDetails;
        data['receivers_info'] = this.selectedAthleteDetails;
        console.log("selected athlete data ", this.selectedAthleteDetails);
      }

      if (this.paymentType == 'pay_per_view') {
        data['ticket_type_name'] = this.ticket_type_name;
        data['tickets'] = this.getTicketIdInv;
        data['ticket_ids'] = this.paymentData.ticket_ids;
        if (this.paymentData.questions)
          data['questions'] = this.paymentData.questions;
        if (this.showShippingForm) {
          data['shipping_address'] = {
            street1: this.getBillingValue.address1,
            city: this.getBillingValue.city,
            state: this.getBillingValue.state,
            state_code: this.codes.state,
            zip: this.getBillingValue.zip,
            country: this.getBillingValue.country.name,
            country_code: this.codes.country
          };
        }
      }
      data['ref_code'] = this.affiliateInfo && this.affiliateInfo.referral_code ? this.affiliateInfo.referral_code : undefined;
      data['referral_code'] = this.affiliateInfo && this.affiliateInfo.referral_code ? this.affiliateInfo.referral_code : undefined;
      data['network_group_id']=this.streamInfo?.network_group_id || this.commanSubscribeService?.activeGroupId || spaceDetails?.networkGroupId || null;

    const refCode = localStorage.getItem('affiliateReferralCode');

    if (data['ref_code'] === undefined && refCode && refCode !== 'undefined') {
      const parsedCode = JSON.parse(refCode);
      data['ref_code'] = parsedCode;
      data['referral_code'] = parsedCode;
    }

      // data['creator_currency'] = this.paymentData?.paymentType == 'charity_donation' ? this.charity_currency?.toLowerCase() : this.creator_currency?.toLowerCase();
      data['creator_currency'] = this.paymentData?.paymentType == 'charity_donation' ? this.charity_currency?.toLowerCase() : 'usd';
      let billingAddress;
      billingAddress = {
        'line1': this.getBillingValue.address1,
        'line2': this.getBillingValue.address2,
        'city': this.getBillingValue.city,
        'state': this.getBillingValue.state,
        'country': this.getBillingValue.country.alpha2code ? this.getBillingValue.country.alpha2code : "",
        'postal_code': this.getBillingValue.zip
      }
      let cardInfo = {
        'card': this.card,
        'billing_details': {
          'name': name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
          'address': billingAddress
        }
      }
      this.toggleLoader('');
      data['guest_id'] = this.performerInfo.guest_id;
      data['address'] = {
        street1: this.getBillingValue.address1 ? this.getBillingValue.address1 : this.selectedBillingAddress && this.selectedBillingAddress.line1 ? this.selectedBillingAddress.line1 : "",
        city: this.getBillingValue.city ? this.getBillingValue.city : this.selectedBillingAddress && this.selectedBillingAddress.city ? this.selectedBillingAddress.city : "",
        state: this.getBillingValue.state ? this.getBillingValue.state : this.selectedBillingAddress && this.selectedBillingAddress.state ? this.selectedBillingAddress.state : "",
        state_code: this.codes.state ? this.codes.state : this.selectedBillingAddress && this.selectedBillingAddress.state_code ? this.selectedBillingAddress.state_code : "",
        zip: this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : "",
        country: this.getBillingValue.country.name ? this.getBillingValue.country.name : this.selectedBillingAddress && this.selectedBillingAddress.country ? this.selectedBillingAddress.country : "",
        country_code: this.codes.country ? this.codes.country : this.selectedBillingAddress && this.selectedBillingAddress.country_code ? this.selectedBillingAddress.country_code : ""
      };

      if (this.paymentType == 'pay_per_view') {
        let formData = this.contactInfoForm.getRawValue();
        let users: any = [];
        if (formData && formData.contactList) {
          formData.contactList.forEach(e => {
            users.push({
              id: e.id,
              first_name: e.user_first_name,
              last_name: e.user_last_name,
              email: e.user_email
            })
          });
        }
        data.users = users;
      }
      data['fee_to_fan'] = this.settingsJSON?.fee_to_fan ? this.settingsJSON?.fee_to_fan : 0;
      if (this.settingsJSON?.fee_to_fan == 1) {
        data['processing_fee_amount'] = this.processingFee;
        data['processing_fee_percentage'] = environment.processing_fee;
        data['processing_fee_fixed'] = environment.fee_percentage;
      } else {
        data['processing_fee_amount'] = 0;
        data['processing_fee_percentage'] = 0;
        data['processing_fee_fixed'] = 0;
      }
      if (this.transactionInfo['mode'] == 'wallet' || this.transactionInfo["mode"] == 'crypto') {
        this.completeTransaction(data);
        return;
      }
      let url = API.GET_CLIENT_SECRET + "?NOLOADER";
      this.appPaymentService.postRequest(url, data).subscribe(result => {
        if (result['status'] == 0) {
          data.transaction_id = result['transaction_id'];
          // this.loader.start();
          this.transactionInfo.stripe.confirmCardPayment(result['client_secret'], {
            payment_method: Object.keys(this.selectedCard).length > 0 ? this.selectedCard.id : cardInfo,
            setup_future_usage: Object.keys(this.selectedCard).length > 0 ? undefined : 'off_session'
            // payment_method: {
            //   card: this.card,
            //   billing_details: {
            //     name: name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name
            //   }
            // }
          }).then((result) => {
            this.loader.stop();
            if (result.error) {
              // Show error to your customer (e.g., insufficient funds)
              this.toastr.error(result.error.message);
            } else {
              // The payment has been processed!
              if (result.paymentIntent.status === 'succeeded') {
                data.response = result.paymentIntent;
                this.completeTransaction(data);

              }
            }
          });
        } else {
          this.commanSubscribeService.updatePaymentBtnSubject.next(true);
          this.showOverlay = false;
          this.toastr.error(result.message)
          this.loader.stop();
        }
      }, error => {
        this.showOverlay = false;
      });
    } else if (!this.cardError) {
      this.cardError = "Please fill all the fields";
    }
  }

  completeTransaction(data) {
    data.response = this.transactionInfo['paymentIntent'] ? this.transactionInfo['paymentIntent'] : data.response;
    data["payment_gateway"] = this.transactionInfo['mode'] == 'wallet' ? "wallet" : this.transactionInfo['mode'] == 'crypto' ? 'crypto' : undefined;
    data["transaction_amount"] = this.transactionInfo['transaction_amount'];
    data["save_card"] = this.transactionInfo['save_card'];
    data["crypto_wallet_id"] = this.transactionInfo.crypto_wallet_id ? this.transactionInfo.crypto_wallet_id : undefined;
    const channelDetails = this.commanSubscribeService.paymentInfo.spaceDetails;

    let url = API.PAYMENT_SUCCESSS + "?NOLOADER";
    this.appPaymentService.postRequest(url, data).subscribe(result => {
      this.showOverlay = false;
      if (result['message'] == 'Success') {
        this.toastr.success("Payment completed Successfully");
        this.commanSubscribeService.sendTriggeredEvent({
          actionType: "purchase",
          clickAction: "PAYMENT_SUCCESS",
          metaData: {
            amount: data['transaction_amount'],
            title: `Payment completed successfully`,
            timeStamp: new Date().toISOString()
          },
          organizationId: this.streamInfo?.organization_id || this.organizationId || null,
          networkGroupId: this.streamInfo?.network_group_id || null,
        });
        // Donation-type payments (tips/charity) additionally count toward the
        // fan's own totalDonatedAmount stat, which reads a separate
        // DONATION_SUCCESS-tagged event rather than PAYMENT_SUCCESS.
        if (['community_tip', 'performer_tip', 'charity_donation'].includes(this.paymentType)) {
          this.commanSubscribeService.sendTriggeredEvent({
            actionType: "purchase",
            clickAction: "DONATION_SUCCESS",
            metaData: {
              amount: data['transaction_amount'],
              title: `Donation completed successfully`,
              timeStamp: new Date().toISOString()
            },
            organizationId: this.streamInfo?.organization_id || this.organizationId || null,
            networkGroupId: this.streamInfo?.network_group_id || null,
          });
        }
        if (this.paymentType == 'community_tip') {
          const athleteName = this.selectedAthleteDetails.personalInfo?.firstName + ' ' + this.selectedAthleteDetails?.personalInfo?.lastName;
          const currencySymbol = CURRENCY_SYMBOLS[this.currency] || this.currency;

          const amount = Number(this.getBillingValue.amount);
          const formattedAmount = amount % 1 === 0 ? amount : amount.toFixed(2);
          const message = `I gave a ${currencySymbol}${formattedAmount} tip to ${athleteName}`;
          // const message = `I gave a ${currencySymbol}${this.getBillingValue.amount} tip to ${athleteName}`;
          const messagePayload = {
            type: "text",
            message: message,
            customType: 'COMMUNITY_CHAT',
            userType: "fan",
            messageId: uuidv4(),
            timestamp: Date.now(),
            files: [],
            _sender: {
              isSender: true,
              profileUrl: this.userInfo.profile_pic || '',
              userId: this.currentUserId,
              nickname: this.userInfo.user_display_name
            },
            publishAt: this.currentUserId,
            pn_gcm: {
              'notification': {
                'title': 'New message in ' + channelDetails.channelName,
                'body': message,
              },
              'data': {
                'channel_id': channelDetails.pubnubId,
                'type': "text",
                'user_id': this.currentUserId,
                'channel_name': channelDetails.channelName
              },
            },
          };
          this.pubnubService.sendMessage(channelDetails.pubnubId, messagePayload, (status) => {
            if (status.error) {
              this.toastr.error("Error while sending auto tip message");
            }
          });

        }
        this.commanSubscribeService.updateAvailBalSubject.next(true);
        if (this.redirectUrl) {
          // this.router.navigateByUrl(this.redirectUrl);
          // this.redirectToHome();
          this.paymentSuccess = true;
          if (this.paymentType == 'pay_per_view')
            this.afterPaymentSuccess.emit("payPerViewSuccess");
        } else {
          this.isPaymentSuccess = true;
        }
      } else {
        this.toastr.error(result['message']);
      }
    });
  }

  redirectToHome() {
    if (this._data && this._data.token) {
      this.dialogRef.close('success');
      this.dialogRef.updatePosition({ top: '150px', left: '250px' });
    } else {
      this.router.navigateByUrl(this.redirectUrl);
    }
  }
  closeModal() {
    this.dialogRef.close('close');
  }

  // toggleDescription(){
  //   this.showDescription = !this.showDescription
  // }

  checkState(country) {
    if (country && country.stateless == "yes") {
      this.billingForm.get("state").setValidators([]);
      this.billingForm.get("state").updateValueAndValidity();
      this.shippingForm.get("state").setValidators([]);
      this.shippingForm.get("state").updateValueAndValidity();
    }
  }

  selectCountry(country, formType) {
    this.countryChanged = false
    this.billingCountry = country.value;
    this.shippingCountry = country.value;
    this.options = {
      types: [],
      componentRestrictions: { country: country.value.alpha2code }
    };
    if (formType == 'billingForm') {
      this.billingForm.patchValue({
        address1: "",
        address2: "",
        city: "",
        state: "",
        // country: "",
        zip: ""
      });
    } else {
      this.shippingForm.patchValue({
        address1: "",
        address2: "",
        city: "",
        state: "",
        // country: "",
        zip: ""
      });
    }
    this.checkState(country.value);
    setTimeout(() => { this.countryChanged = true });
  }

  selectAthlete(event) {
    const details = event.value;
    this.selectedAthleteDetails = details;
    if (this.billingForm?.get('amount').value) {
      this.commonSubscribeService.formsValidationSubject.next(true);
    } else {
      this.commonSubscribeService.formsValidationSubject.next(false);
    }

  }

  // openEventTermsConditions(isAgrees) {
  //   if (isAgrees) {
  //     const dialogRef = this._matDialog.open(EventTermsConditionsComponent, {
  //       // maxWidth:"320px",
  //       panelClass: "app-event-terms",
  //       disableClose: true,
  //       data: {}
  //     });
  //     dialogRef.afterClosed().subscribe(result => {
  //     });
  //   }
  // }

  buildContactInfoForm() {
    this.contactInfoForm = this.formBuilder.group({
      contactList: this.formBuilder.array([])
    });

    let contactListCtrl = <FormArray>this.contactInfoForm.controls.contactList;
    contactListCtrl.controls = [];
    for (let i = 0; i < parseInt(this.noOfTicket); i++) {
      contactListCtrl.push(
        this.formBuilder.group({
          id: [],
          user_first_name: [{ value: "", disabled: false }, Validators.required],
          user_last_name: [{ value: "", disabled: false }, Validators.required],
          user_email: [{ value: "", disabled: false }, [Validators.required, ValidationService.emailValidator]]
        })
      );
    }
  }

  get contactList(): FormArray {
    return this.contactInfoForm.get('contactList') as FormArray;
  }

  saveOtherUserTicket() {
    if (this.contactInfoForm.valid) {
      let userList = this.contactInfoForm.getRawValue().contactList;
      let userBookedList = [];
      let resCount = 0;

      userList.forEach((element, id) => {
        this.checkOtherUsers(element, id).then((data: any) => {
          if (data && data.result) {
            this.contactList.controls[data.index].patchValue({
              id: data.result.user.id
            });
            let isBooked = false;
            if (data.result.tickets && data.result.tickets > 0) {
              this.ticketIds.forEach(e => {
                let index = data.result.tickets.findIndex(a => a == e);
                if (index != -1) {
                  isBooked = true;
                }
              });
            }
            if (data.result.tickets && data.result.tickets > 0 && isBooked) {
              userBookedList.push(element.user_email);
            }
          }
          resCount++;
          if (resCount == userList.length && userBookedList.length != 0) {
            this.toastr.error("Already booked stream ticket for these users " + userBookedList.toString());
            this.isEnteredOtherUser = false;
          } else if (resCount == userList.length) {
            this.isEnteredOtherUser = true;
          }
        }).catch(error => {
        });
      });
    }
  }

  checkOtherUsers(userDetail, index) {

    return new Promise((resolve, reject) => {
      let data = {
        "firstname": userDetail.user_first_name,
        "lastname": userDetail.user_last_name,
        "email": userDetail.user_email.toLowerCase(),
        "stream_id": this.streamId,
        "organization_id": this.streamInfo.organization_id
      };
      this.appService.postRequest(API.GET_USER_BY_EMAIL, data).subscribe(result => {
        if (result.status == 0) {
          let res = {
            result: result,
            index: index
          }
          resolve(res);
        }
      }, error => {
        reject(error)
      });
    });
  }

  setUniqueEmail(i) {
    let list = this.contactInfoForm.getRawValue().contactList;
    let currentRow = list[i];
    let foundDuplicate = false;
    list.forEach((e, index) => {
      if (e.user_email == currentRow.user_email && index != i) {
        foundDuplicate = true;
      }
    });
    if (foundDuplicate) {
      this.contactList.controls[i].patchValue({
        user_email: ""
      });
      this.toastr.error("Please give unique email");
    }
  }

  changeCurrency(event) {
    let getVal = event.value.split(' -');
    this.currencyVal = event.value;
    let val = this.currencyVal.split(' -');
    if (this.curWithoutDecimals.includes(val[0])) {
      this.allowDecimals = false;
    } else {
      this.allowDecimals = true;
    }
    this.currency = getVal[0];
    if (this.rates) {
      this.conversionRate = this.rates[this.currency];
    }
    this.storageService.setItem('currency', getVal[0]);
    this.getCurrency = getVal[0];
    this.billingForm.patchValue({
      amount: ''
    });

    if (this.rates) {
      Object.keys(this.rates).forEach(rates => {
        if (this.currency == rates) {
          // Matches the 2.5% conversion markup already applied to the wallet's own
          // "1 $ equivalent to ..." figure (payment-transactions.component.ts's convRate).
          this.minAmount = Number((this.rates[rates] * 1.025).toFixed(2));
        }
      })
    }

    this.selectedTransaction = '';
  }

  onPaymentAreaClick() {
    this.paymentAreaClicked = true;
    this.billingForm.markAllAsTouched();
    this.billingForm.updateValueAndValidity();
  }

  ngOnDestroy() {
    this.card = '';
    if (this.paymentInfoSubscription)
      this.paymentInfoSubscription.unsubscribe();
    if (this.selectedCardInfoSubscr) {
      this.selectedCardInfoSubscr.unsubscribe();
    }
    if (this.addressListInfoSubscr) {
      this.addressListInfoSubscr.unsubscribe();
    }
    if (this.savedCardsListSubscr) {
      this.savedCardsListSubscr.unsubscribe();
    }
    if (this.transactionInfoSubscr) {
      this.transactionInfoSubscr.unsubscribe();
    }
    if (this.formStatusSubscr) {
      this.formStatusSubscr.unsubscribe();
    }
    this.performerInfoSubscription?.unsubscribe();
  }
}
